import React, { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AuditTrail() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/supervisor/audit-log?limit=500").then((r) => setRows(r.data)); }, []);
  const filtered = rows.filter((r) => !q || r.action.includes(q.toLowerCase()) || (r.user_email || "").includes(q.toLowerCase()));
  return (
    <AppLayout title="Audit Trail" subtitle="Chronological log of system actions" actions={
      <Input placeholder="Search action / user…" className="rounded-sm w-72" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
    }>
      <div className="surface-grid">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left tab-tag text-slate-500"><th className="px-4 py-2">Timestamp</th><th className="px-4 py-2">User</th><th className="px-4 py-2">Role</th><th className="px-4 py-2">Action</th><th className="px-4 py-2">Details</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (<tr><td colSpan={5} className="px-4 py-6 text-slate-500">No events.</td></tr>) :
              filtered.map((r) => (
                <tr key={r.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-2 mono text-xs">{new Date(r.timestamp).toLocaleString()}</td>
                  <td className="px-4 py-2">{r.user_name} <span className="text-xs text-slate-500">({r.user_email})</span></td>
                  <td className="px-4 py-2 mono uppercase text-xs">{r.user_role}</td>
                  <td className="px-4 py-2 mono">{r.action}</td>
                  <td className="px-4 py-2 mono text-xs text-slate-500 truncate max-w-[400px]">{JSON.stringify(r.details)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
